export type CaregiverApiDto = {
  id: string;
  organizationId: string;
  firstName: string;
  lastName: string;
  displayName: string;
  schedulingName?: string;
  isPrescriber: boolean;
};

export type Caregiver = CaregiverApiDto;

export const toCaregiver = (dto: CaregiverApiDto): Caregiver => ({ ...dto });
